//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import directHeading from '~/components/content/direct/directHeading.vue';
import directSection from '~/components/content/direct/directSection.vue';
import directActionsBlock from '~/components/content/direct/directActionsBlock.vue';

export default {
  name: 'directSectionTop',
  components: {
    directHeading,
    directSection,
    directActionsBlock,
  },
};
